module.exports = __webpack_public_path__ + "static/turquia-019.thumb-6e365cb97e5bf55769ee04362fb22e5b.jpg";